import { Alert } from "@volca/ui/components/ui/alert";
import { Input } from "@volca/ui/components/ui/input";
import { Label } from "@volca/ui/components/ui/label";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { SERVICE_TITAN_STAGE, type ServiceTitanStage } from "./types";

// What the customer still has to do, once Volca has asked ServiceTitan for access to
// their tenant. Only an administrator can approve the request, which is why the
// administrator branch never reaches this.
const ACCEPT_STEPS: readonly string[] = [
  "In ServiceTitan, open Settings, then Integrations, then API Application Access.",
  "Find the pending request from Volca.",
  "Approve it, and leave the permissions as they are.",
];

export const StLimitedUserSetup = ({
  tenant,
  stage,
  onTenantChange,
}: {
  tenant: string;
  stage: ServiceTitanStage;
  onTenantChange: (value: string) => void;
}) => (
  <Stack className="w-full" gap={4} align="stretch">
    <Stack className="w-full" gap={1} align="stretch">
      <Label htmlFor="st-tenant-id">ServiceTitan tenant ID</Label>
      <Input
        id="st-tenant-id"
        value={tenant}
        maxLength={64}
        placeholder="123456789"
        onChange={(event) => onTenantChange(event.target.value)}
      />
      <Text variant="caption" tone="muted">
        You'll find it in Settings, in the web address, or on the integrations
        page.
      </Text>
    </Stack>

    {stage === SERVICE_TITAN_STAGE.awaitingVolca && (
      <Alert>
        Got it. We're setting the connection up now, and we'll email you when
        there's one thing left to do.
      </Alert>
    )}

    {stage === SERVICE_TITAN_STAGE.awaitingAcceptance && (
      <Stack className="w-full" gap={1} align="stretch">
        <Text weight="semibold" variant="caption">
          One thing left: approve our request
        </Text>
        <ol className="text-md list-decimal space-y-1 pl-5 text-subtle">
          {ACCEPT_STEPS.map((text) => (
            <li key={text}>
              <Text tone="muted">{text}</Text>
            </li>
          ))}
        </ol>
        <Text variant="caption" tone="muted">
          Once you approve it we start reading your jobs and invoices. Carry on
          with the rest of your setup in the meantime.
        </Text>
      </Stack>
    )}
  </Stack>
);
